import { useAxios } from '@/hooks/useAxios';
import { useQuery } from '@/utils/api';

export interface ProviderCredits {
  plugin: string;
  remaining: number;
  used: number;
  allowed: number;
  available: boolean;
}

export function usePluginCredits(enabled = true) {
  const axios = useAxios({ doNotImpersonate: true });

  return useQuery<Map<string, ProviderCredits>>({
    defaultErrorMessage: 'Failed to fetch plugin credits',
    queryKey: ['enrichment', 'credits'],
    enabled,
    staleTime: 60_000,
    queryFn: async () => {
      const { data } = await axios.get('/enrichment/credits');
      const arr = data as ProviderCredits[];
      const map = new Map<string, ProviderCredits>();
      for (const item of arr) {
        if (item.available) {
          map.set(item.plugin, item);
        }
      }
      return map;
    },
  });
}
